import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-589a3446"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "px-10 border-b pb-3 gap-4 flex justify-between" }
const _hoisted_2 = { class: "flex flex-col gap-3 flex-shrink-0 overflow-hidden max-w-75pct" }
const _hoisted_3 = { class: "flex items-center gap-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "w-15 flex-shrink-0" }, "From", -1))
const _hoisted_5 = { class: "max-w-xl" }
const _hoisted_6 = { class: "flex items-center gap-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "w-15 flex-shrink-0" }, "To", -1))
const _hoisted_8 = { class: "whitespace-nowrap overflow-hidden overflow-ellipsis" }
const _hoisted_9 = { class: "max-w-xl" }
const _hoisted_10 = {
  key: 0,
  class: "flex items-center gap-3"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "w-15 flex-shrink-0" }, "CC", -1))
const _hoisted_12 = { class: "whitespace-nowrap overflow-hidden overflow-ellipsis" }
const _hoisted_13 = { class: "max-w-xl" }
const _hoisted_14 = {
  key: 1,
  class: "flex items-center gap-3 overflow-hidden"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "w-15 flex-shrink-0" }, "Subject", -1))
const _hoisted_16 = { class: "whitespace-nowrap overflow-hidden overflow-ellipsis" }
const _hoisted_17 = { class: "max-w-xl" }
const _hoisted_18 = { class: "flex flex-col gap-2 overflow-hidden" }
const _hoisted_19 = { class: "text-right" }
const _hoisted_20 = {
  key: 0,
  class: "flex items-center gap-2"
}
const _hoisted_21 = { class: "whitespace-nowrap overflow-hidden overflow-ellipsis" }
const _hoisted_22 = { class: "max-w-xl" }

import { AttributeType } from '@/attributes';
import { Contact } from '@/contacts';
import {
	ConversationMessage,
	useMessages
} from '@/inbox/composition';
import {
	useEmails,
	useFax,
	usePhysicalMail
} from '@/messenger';
import { UiAvatar, Tooltip } from '@/ui-kit';
import { useAvailablePhoneNumbers } from '@/phone-numbers/composition/use-available-phone-numbers';
import { useTeams } from '@/team';
import { capitalize } from '@/utils';
import { useCompanyProfile } from '@/account';
import { computed } from 'vue';
import { RoutableSyncButton } from '@/interations';


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageDetailsHeader',
  props: {
    message: null,
    contact: null
  },
  setup(__props: any) {

const props = __props as {
	message: ConversationMessage;
	contact: Contact;
};

const { fullMessageCreatedAt } = useMessages();
const { phoneNumbers } = useAvailablePhoneNumbers();
const { emails } = useEmails();
const { faxNumbers } = useFax();
const { addresses, getAddressTitle } = usePhysicalMail();
const { getTeamMember } = useTeams();
const { userId } = useCompanyProfile();



const isInbound =
	props.message.content.direction === 'incoming';

function getAttributeTypeByMessageType(): AttributeType | null {
	switch (props.message.type) {
		case 'email':
			return AttributeType.email;
		case 'call':
		case 'text-message':
			return AttributeType.phone;
		case 'physical-mail':
			return AttributeType.address;
		case 'fax':
			return AttributeType.fax_phone;
		default:
			return null;
	}
}

function getToValues(sender: string): {
	name: string;
	value: string;
} | null {
	switch (props.message.type) {
		case 'email': {
			const value = emails.value.find(
				(email) =>
					sender.includes(email.email) ||
					email.hash === sender
			);

			if (!value) {
				return null;
			}

			return {
				name: value.name,
				value: value.email
			};
		}
		case 'call':
		case 'text-message': {
			const value = phoneNumbers.value.find(
				(number) => number.phoneNumber === sender
			);

			if (!value) {
				return null;
			}

			return {
				name: value.friendlyName,
				value: value.phoneNumber
			};
		}
		case 'physical-mail': {
			const value = addresses.value.find(
				(address) => {
					return (
						address.address === sender ||
						getAddressTitle(address) === sender
					);
				}
			);

			if (!value) {
				return null;
			}

			return {
				name: value.name,
				value: getAddressTitle(value)
			};
		}
		case 'fax': {
			const value = faxNumbers.value.find(
				(number) => number.phoneNumber === sender
			);

			if (!value) {
				return null;
			}

			return {
				name: value.friendlyName,
				value: value.phoneNumber
			};
		}
		default:
			return null;
	}
}

function getCompanyAttribute(sender: string) {
	const toValues = getToValues(sender);

	if (!toValues) {
		return sender;
	}

	const { name, value } = toValues;

	if (name === value) {
		return value;
	}

	return `${name} (${value})`;
}

function contactAddressAttr(addressStr: string) {
	const {
		address_city,
		address_country,
		address_line1,
		address_line2,
		address_state,
		address_zip
	} = JSON.parse(addressStr) as any;

	return {
		city: address_city,
		state: address_state,
		zip: address_zip,
		address_line1: address_line1,
		address_line2: address_line2 || ''
	};
}

function getContactAttribute(sender: string) {
	const fromAttr = props.contact.attributes
		.filter(
			(attr) =>
				attr.type ===
				getAttributeTypeByMessageType()
		)
		.find((attr) => {
			const value =
				attr.type === AttributeType.address
					? getAddressTitle(attr.value)
					: attr.value;
			const senderValue =
				attr.type === AttributeType.address
					? getAddressTitle(
							contactAddressAttr(sender)
					  )
					: sender;

			return value === senderValue;
		});

	if (!fromAttr) {
		return sender;
	}

	return `${fromAttr.is_primary ? 'Primary ' : ''}${
		fromAttr.name
	} (${
		fromAttr.type === AttributeType.address
			? getAddressTitle(fromAttr.value)
			: fromAttr.value
	})`;
}

const from = getFrom();
const to = getTo();
const cc = computed(() => {
	if ('cc' in props.message.content) {
		return (
			props.message.content.cc
				?.map((item) =>
					typeof item === 'string'
						? item
						: item.display
				)
				.join(', ') || ''
		);
	}

	return '';
});

function getFrom() {
	return isInbound
		? getContactAttribute(props.message.from)
		: getCompanyAttribute(props.message.from);
}

function getTo() {
	return isInbound
		? getCompanyAttribute(props.message.to)
		: getContactAttribute(props.message.to);
}

function getSenderText() {
	if (!props.message.sender) {
		return '';
	}

	const name =
		userId.value === props.message.sender.id
			? 'you'
			: props.message.sender.name;

	if (props.message.type === 'call') {
		return `Call
						${isInbound ? 'answered by' : 'made by'}
						${name}`;
	}

	return `${capitalize(props.message.type).replace(
		'-',
		' '
	)} sent by ${name}`;
}

const senderText = getSenderText();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_unref(Tooltip), { class: "whitespace-nowrap overflow-hidden overflow-ellipsis" }, {
          popper: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(from)), 1)
          ]),
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_unref(from)), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(_unref(Tooltip), null, {
          popper: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(to)), 1)
          ]),
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(to)), 1)
          ]),
          _: 1
        })
      ]),
      (_unref(cc))
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_unref(Tooltip), null, {
              popper: _withCtx(() => [
                _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(cc)), 1)
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(cc)), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (__props.message.type === 'email')
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _hoisted_15,
            _createVNode(_unref(Tooltip), null, {
              popper: _withCtx(() => [
                _createElementVNode("div", _hoisted_17, _toDisplayString(__props.message.content.subject), 1)
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_16, _toDisplayString(__props.message.content.subject), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(fullMessageCreatedAt)(__props.message.created_at)), 1),
      (__props.message.sender)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createVNode(_unref(Tooltip), { class: "whitespace-nowrap overflow-hidden overflow-ellipsis" }, {
              popper: _withCtx(() => [
                _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(senderText)), 1)
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(senderText)), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(UiAvatar), {
              withShadow: "",
              avatar: 
						_unref(getTeamMember)(__props.message.sender.id)
							?.avatar?.path
					,
              name: __props.message.sender.name,
              class: "h-7 w-7 flex-shrink-0"
            }, null, 8, ["avatar", "name"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})